import DevelopmentPage from '@totem/components/development/DevelopmentPage';
import OrgSelectorTest from '@totem/components/development/OrgSelectorTest';
import MobileApplications from '@totem/components/mobile/MobileApplications';
import ReportPage from '@totem/components/reports/ReportsPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const applicationRoutes: Route[] = [
  {
    path: 'apps',
    pageTitle: 'Mobile Application',
    component: MobileApplications,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'reports',
    pageTitle: 'Reports',
    component: ReportPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'development',
    pageTitle: 'Development',
    component: DevelopmentPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'development/orgSelector',
    pageTitle: 'Organization Selector',
    component: OrgSelectorTest,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
